import { communicationsBeforeEnter as beforeEnter } from '@/router/middlewares/communicationsAccess';
import { screen } from '@/router/screenRoutes';

export default [
  {
    ...screen('comunicacoes-list'),
    component: () => import('@/views/comunicacoes/ComunicacoesList.vue'),
    beforeEnter,
    props: true,
  },
  {
    ...screen('comunicacoes-tracking'),
    component: () => import('@/views/comunicacoes/ComunicacoesTracking.vue'),
    beforeEnter,
  },
  {
    ...screen('comunicacoes-create'),
    component: () => import('@/views/comunicacoes/ComunicacaoWizard.vue'),
    beforeEnter,
    props: { id: null },
  },
  {
    ...screen('comunicacoes-edit'),
    component: () => import('@/views/comunicacoes/ComunicacaoWizard.vue'),
    beforeEnter,
    props: true,
  },
  {
    ...screen('comunicacoes-performance'),
    component: () => import('@/views/comunicacoes/ComunicacaoDesempenho.vue'),
    beforeEnter,
    props: true,
  },
];
